import { render } from "./CookieConsent.vue?vue&type=template&id=20e15198&lang=pug"
import script from "./CookieConsent.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieConsent.vue?vue&type=script&setup=true&lang=js"

import "./CookieConsent.vue?vue&type=style&index=0&id=20e15198&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__